export default __webpack_public_path__ + "static/media/Meir Shtiglitz.7f168565.docx";